export default {
  title: 'Tuloraportit',
  sections: {
    new_report: 'Uusi raportti',
  },
  form: {
    period: {
      label: 'Jakso',
    },
  },
  buttons: {
    export: 'Vie',
  },
  toasts: {
    failed_to_create_report: 'Raportin luonti epäonnistui',
  },
};
